import React from 'react';
import { Link } from 'react-router-dom'

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';


export const Privacy = ({}) => {



	return (
    <div className="container-fluid appdesc corners">
 <div className="row padrow">
   <div className="col-md-12 col-lg-12">
         <h2>Privacy Policy</h2>
   </div>
   </div>
   <div className="row padrow">
   <div className="col-md-12 col-lg-12">
        This is the privacy policy of Helen's Software Company.  It applies to all of our applications, including ABC Drop Bubble Pop, Burp the Cow, First Then 1 to 4, Floaty Words, Glass Elevator Ride, Snappy Shoe Race Lite, Wobbly ABC, Audit Attack Lite, and Audit Attack Two.
   </div>
   </div>
  <div className="row padrow">
<div className="col-md-12 col-lg-12">
       <p>The goal of Helen's Software Company is to provide useful and/or fun applications to aid children.  We do not track, collect, upload, download, or save any of your personal data in any of our children's apps.  Any settings or text input, or photos taken or accessed, are stored only on your device.  In the course of delivering our apps to you, some information may be accessed as follows:</p>
 		 	<ol>
       <li>Information on the use of our app that may be collected by Apple through the App Store or Google through their Google play store.</li>
       <li>For Audit Attack and Audit Attack Two Google Play apps only, our free apps use AdMob advertising from Google, which may also track certain information.</li>
       </ol>

			<p>A link to Apple's privacy policy is <a href="https://www.apple.com/legal/privacy/en-ww/">here</a>.</p>
      <p>Links to Google's privacy policies are <a href="http://www.google.com/policies/privacy/">here</a> and <a href="http://www.google.com/policies/privacy/partners/">here.</a>   A link to the Google page to opt-out of personalized advertising is <a href="https://www.google.com/settings/u/0/ads/authenticated">here.</a></p>


         </div>
   </div>


 </div>

			)


}
